import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import "assets/css/view-uploadedID.css";

const ViewUploadedID = ({ idUrl, isImage = true, isOpen, toggle, isIdImage }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>
        Uploaded {isIdImage ? "ID" : isImage ? "Image" : "Video"}
      </ModalHeader>

      <ModalBody className="d-flex justify-content-center p-3 align-items-center p-3">
      {isImage ? (
        <Zoom>
          <img
            src={idUrl}
            alt="Uploaded"
            className="rounded shadow-sm uploaded-preview zoom-able"
          />
        </Zoom>

      ) : (
        <video
          src={idUrl}
          controls
          className="rounded shadow-sm uploaded-preview"
        />
      )}
      </ModalBody>
    </Modal>
  );
};

export default ViewUploadedID;
